import type { DriverNominateTripImageInput } from '@cobliteam/common-types';
import type { DriverNominateTripImageInputAPI } from './definitions';

export const toTripImageHistoryUpdateRequestAPI = (input: DriverNominateTripImageInput[]): DriverNominateTripImageInputAPI[] =>
  input.map((req) => ({
    trip_id: req.tripId,
    driver_id: req.driverId,
    image_id: req.imageId,
    operation: req.operation,
    driver_visibility: req.driverVisibility,
    image_url: req.imageUrl,
  }));
